import { STEP_CREATE, STEP_VERIFY, STEP_CHOOSE, STEP_FINISH } from "Signup";
import { SIGNUP_USER, REGISTER_OTP } from "Actions";
import _ from "lodash";
export var SIGNUP_STEP = "signup_step";
export var SIGNUP_FEATURE_SELECT = "SIGNUP_FEATURE_SELECT";
export var PROCEED_TO_DASHBOARD = "proceed_to_dashboard";
export var RESET_ENTERED_OTP = "RESET_ENTERED_OTP";

export var SignupStepReducer = (state = STEP_CREATE, action) => {
  if (action.type === SIGNUP_STEP) {
    return action.payload;
  }
  return state;
};

export var SignupRegisterReducer = (state = {}, action) => {
  if (action.type === SIGNUP_USER) {
    return action.payload;
  }
  return state;
};

export var SignupOTP = (state = "", action) => {
  if (action.type === REGISTER_OTP) {
    return action.payload;
  }
  return state;
};

export var ResetSignupOTP = (state = false, action) => {
  if (action.type === RESET_ENTERED_OTP) {
    return action.payload;
  }
  return state;
};

export var SignupSelectedFeature = (state = [], action) => {
  if (action.type === SIGNUP_FEATURE_SELECT) {
    if (state.indexOf(action.payload) === -1) {
      return [...state, action.payload];
    } else {
      state = _.reject(state, action.payload);
      return [...state];
    }
  }
  return state;
};

export function ProceedToDashboard(state = false, action) {
  if (action.type === PROCEED_TO_DASHBOARD) {
    return true;
  }
  return state;
}
